import { Action } from "redux"
import { ILinkedDocument } from "./index"

export const INITIALIZE = "INLINEATTACHMENT_INITIALIZE"
export const RECEIVE_ATTACHMENTS = "INLINEATTACHMENT_RECEIVE_ATTACHMENTS"
export const REQUEST_ATTACHMENTS = "INLINEATTACHMENT_REQUEST_ATTACHMENTS"
export const REQUEST_ADD_ATTACHMENT = "INLINEATTACHMENT_REQUEST_ADD_ATTACHMENT"
export const REQUEST_DELETE_ATTACHMENT =
    "INLINEATTACHMENT_REQUEST_DELETE_ATTACHMENT"
export const LOAD_MORE_ATTACHMENTS = "INLINEATTACHMENT_LOAD_MORE_ATTACHMENTS"
export const ATTACHMENT_LOADED = "INLINEATTACHMENT_ATTACHMENT_LOADED"
export const UPDATE_ATTACHMENT_DESCRIPTION =
    "INLINEATTACHMENT_UPDATE_ATTACHMENT_DESCRIPTION"

export interface ReceiveAttachments extends Action {
    linkedDocuments: ILinkedDocument[]
    customFieldDefinitionId: string
}

export interface RequestAttachments extends Action {
    itemId: number
    customFieldDefinitionId: string
}

export interface RequestAddAttachment extends Action {
    itemId: number
    customFieldDefinitionId: string
    formData: FormData
}

export interface RequestDeleteAttachment extends Action {
    itemId: number
    customFieldDefinitionId: string
    linkedDocumentId: number
}

export interface UpdateAttachmentDescription extends Action {
    objectId: number
    value: string
    itemId: number
    customFieldDefinitionId: string
}

export interface ActionWithCustomFieldId extends Action {
    customFieldDefinitionId: string
}

export const initialize = (
    customFieldDefinitionId: string,
): ActionWithCustomFieldId => ({
    type: INITIALIZE,
    customFieldDefinitionId,
})

export const receiveAttachments = (
    linkedDocuments: ILinkedDocument[],
    customFieldDefinitionId: string,
): ReceiveAttachments => ({
    type: RECEIVE_ATTACHMENTS,
    linkedDocuments,
    customFieldDefinitionId,
})

export const requestAttachments = (
    itemId: number,
    customFieldDefinitionId: string,
): RequestAttachments => ({
    type: REQUEST_ATTACHMENTS,
    itemId,
    customFieldDefinitionId,
})

export const requestAddAttachment = (
    itemId: number,
    customFieldDefinitionId: string,
    formData: FormData,
): RequestAddAttachment => ({
    type: REQUEST_ADD_ATTACHMENT,
    itemId,
    customFieldDefinitionId,
    formData,
})

export const requestDeleteAttachment = (
    itemId: number,
    customFieldDefinitionId: string,
    linkedDocumentId: number,
): RequestDeleteAttachment => ({
    type: REQUEST_DELETE_ATTACHMENT,
    itemId,
    customFieldDefinitionId,
    linkedDocumentId,
})

export const loadMoreAttachments = (
    customFieldDefinitionId: string,
): ActionWithCustomFieldId => ({
    type: LOAD_MORE_ATTACHMENTS,
    customFieldDefinitionId,
})

export const attachmentLoaded = (
    customFieldDefinitionId: string,
): ActionWithCustomFieldId => ({
    type: ATTACHMENT_LOADED,
    customFieldDefinitionId,
})

export const updateAttachmentDescription = (
    objectId: number,
    value: string,
    itemId: number,
    customFieldDefinitionId: string,
): UpdateAttachmentDescription => ({
    type: UPDATE_ATTACHMENT_DESCRIPTION,
    objectId,
    value,
    itemId,
    customFieldDefinitionId,
})

export const REGISTER_FEEDBACK = "INLINEATTACHMENT_REGISTER_FEEDBACK"

export interface RegisterFeedback extends Action {
    itemId: number
    customFieldDefinitionId: string
}

export const registerFeedback = (
    itemId: number,
    customFieldDefinitionId: string,
): RegisterFeedback => ({
    type: REGISTER_FEEDBACK,
    itemId,
    customFieldDefinitionId,
})

export const mapDispatchToProps = {
    initialize,
    receiveAttachments,
    requestAttachments,
    requestAddAttachment,
    requestDeleteAttachment,
    loadMoreAttachments,
    attachmentLoaded,
    updateAttachmentDescription,
    registerFeedback,
}

export type DispatchProps = typeof mapDispatchToProps
